// 智能去背景：只清除与图片边缘连通、且纹理平滑的浅色区域；主体内部或带纹理的白色（白胸口、眼白）会保留。
// 全部在本机计算，图片不会上传。strength 0–100：越大越积极。
export function edgeBackgroundMask(data, width, height, strength = 50) {
  const n = width * height;
  const lum = new Float32Array(n);
  for (let i = 0, p = 0; i < n; i++, p += 4) lum[i] = data[p + 3] < 24 ? 255 : 0.2126 * data[p] + 0.7152 * data[p + 1] + 0.0722 * data[p + 2];
  // 3×3 局部起伏：背景平滑，毛发、纸纹有起伏
  const rough = new Float32Array(n);
  for (let y = 0; y < height; y++) for (let x = 0; x < width; x++) {
    let lo = 255, hi = 0;
    for (let dy = -1; dy <= 1; dy++) { const yy = Math.min(height - 1, Math.max(0, y + dy));
      for (let dx = -1; dx <= 1; dx++) { const v = lum[yy * width + Math.min(width - 1, Math.max(0, x + dx))]; if (v < lo) lo = v; if (v > hi) hi = v; } }
    rough[y * width + x] = hi - lo;
  }
  // 背景色：边缘浅色像素的中位数
  const border = [];
  const push = (i) => { const p = i * 4; if (data[p + 3] < 24) return; border.push(i); };
  for (let x = 0; x < width; x++) { push(x); push((height - 1) * width + x); }
  for (let y = 0; y < height; y++) { push(y * width); push(y * width + width - 1); }
  const light = border.filter((i) => lum[i] > 170);
  const mask = new Uint8Array(n);
  if (light.length < Math.max(8, border.length * 0.3)) {
    for (let i = 0; i < n; i++) if (data[i * 4 + 3] < 24) mask[i] = 1;
    return mask;
  }
  const med = (c) => { const v = light.map((i) => data[i * 4 + c]).sort((a, b) => a - b); return v[v.length >> 1]; };
  const br = med(0), bg = med(1), bb = med(2);
  const s = Math.max(0, Math.min(100, strength)) / 100;
  const tol = 10 + 40 * s;          // 与背景色的距离容差
  const roughMax = 6 + 22 * s;      // 允许的局部起伏
  const stepMax = 4 + 10 * s;       // 相邻像素的亮度跳变（渐变允许缓慢变化）
  const cand = (i) => {
    const p = i * 4; if (data[p + 3] < 24) return true;
    const dr = data[p] - br, dg = data[p + 1] - bg, db = data[p + 2] - bb;
    return dr * dr + dg * dg + db * db <= tol * tol && rough[i] <= roughMax;
  };
  const q = new Int32Array(n); let h = 0, t = 0;
  const seed = (i) => { if (!mask[i] && cand(i)) { mask[i] = 1; q[t++] = i; } };
  for (let x = 0; x < width; x++) { seed(x); seed((height - 1) * width + x); }
  for (let y = 0; y < height; y++) { seed(y * width); seed(y * width + width - 1); }
  while (h < t) {
    const i = q[h++], x = i % width;
    const go = (j) => { if (!mask[j] && Math.abs(lum[j] - lum[i]) <= stepMax && cand(j)) { mask[j] = 1; q[t++] = j; } };
    if (x > 0) go(i - 1); if (x + 1 < width) go(i + 1); if (i >= width) go(i - width); if (i + width < n) go(i + width);
  }
  // 边缘渐变：沿已清除区域向内吃掉几圈浅色、低彩度的过渡像素，避免主体外留一圈白边
  const rounds = Math.round(2 + 6 * s);
  let frontier = [];
  for (let i = 0; i < n; i++) if (mask[i]) frontier.push(i);
  for (let r = 0; r < rounds && frontier.length; r++) {
    const next = [];
    for (const i of frontier) {
      const x = i % width;
      for (const j of [x > 0 ? i - 1 : -1, x + 1 < width ? i + 1 : -1, i - width, i + width]) {
        if (j < 0 || j >= n || mask[j]) continue;
        const pp = j * 4, c = Math.max(data[pp], data[pp + 1], data[pp + 2]) - Math.min(data[pp], data[pp + 1], data[pp + 2]);
        if (lum[j] > 175 - 30 * s && c < 48) { mask[j] = 1; next.push(j); }
      }
    }
    frontier = next;
  }
  return mask;
}
export function applyBackgroundMask(data, width, height, strength) {
  const mask = edgeBackgroundMask(data, width, height, strength);
  const out = new Uint8ClampedArray(data);
  let cleared = 0;
  for (let i = 0; i < mask.length; i++) if (mask[i]) { out[i * 4 + 3] = 0; cleared++; }
  return { data: out, cleared };
}
